/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointmentTypeDto
 */
export interface AppointmentTypeDto {
    /**
     * Appointment type ID
     * @type {string}
     * @memberof AppointmentTypeDto
     */
    id: string;
    /**
     * Appointment type name
     * @type {string}
     * @memberof AppointmentTypeDto
     */
    name: string;
    /**
     * Appointment type color code
     * @type {string}
     * @memberof AppointmentTypeDto
     */
    colorCode: string;
    /**
     * Appointment type duration in minutes
     * @type {number}
     * @memberof AppointmentTypeDto
     */
    duration: number;
    /**
     * Appointment type practice ID
     * @type {string}
     * @memberof AppointmentTypeDto
     */
    practiceId: string;
}

/**
 * Check if a given object implements the AppointmentTypeDto interface.
 */
export function instanceOfAppointmentTypeDto(value: object): value is AppointmentTypeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('colorCode' in value) || value['colorCode'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('practiceId' in value) || value['practiceId'] === undefined) return false;
    return true;
}

export function AppointmentTypeDtoFromJSON(json: any): AppointmentTypeDto {
    return AppointmentTypeDtoFromJSONTyped(json, false);
}

export function AppointmentTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'colorCode': json['colorCode'],
        'duration': json['duration'],
        'practiceId': json['practiceId'],
    };
}

export function AppointmentTypeDtoToJSON(json: any): AppointmentTypeDto {
    return AppointmentTypeDtoToJSONTyped(json, false);
}

export function AppointmentTypeDtoToJSONTyped(value?: AppointmentTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'colorCode': value['colorCode'],
        'duration': value['duration'],
        'practiceId': value['practiceId'],
    };
}

